// src/components/Kanban.js
import React from "react";

const Kanban = ({ columnsConfig, cardRenderer }) => {
    const headerColors = {
        "Pendientes": "bg-primary text-white",
        "Atrasados": "text-dark",
        "Recibido Parcialmente": "text-dark",
        "Recibidos": "text-dark",
    };

    const headerStyles = {
        "Atrasados": { backgroundColor: "#f8d7da" },
        "Recibido Parcialmente": { backgroundColor: "#fff3cd" },
        "Cumplidos": { backgroundColor: "#d4edda" },
    };
    
    return (
        <div className="d-flex overflow-auto gap-2">
            {columnsConfig.map((col, idx) => (
                <div key={idx} style={{ minWidth: "250px", maxWidth: "300px" }}>
                    <div
                        className={`text-center p-2 rounded-top ${headerColors[col.title] || ""}`}
                        style={headerStyles[col.title] || {}}
                    >
                        {col.title} ({col.data.length})
                    </div>
                    <div className="border rounded-bottom p-1 bg-light" style={{ minHeight: "300px", maxHeight: "80vh", overflowY: "auto" }}>
                        {col.data.map((item, idxItem) => (
                            <div key={idxItem} className="mb-2">
                                {cardRenderer(item)}
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Kanban;
